/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SearchAddressGeometryDto } from '../../models/search-address-geometry-dto';

export interface SearchForRoadGeometry$Params {
  pfi: string;
}

export function searchForRoadGeometry(
  http: HttpClient,
  rootUrl: string,
  params: SearchForRoadGeometry$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SearchAddressGeometryDto>> {
  const rb = new RequestBuilder(rootUrl, searchForRoadGeometry.PATH, 'get');
  if (params) {
    rb.query('pfi', params.pfi, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SearchAddressGeometryDto>;
      }),
    );
}

searchForRoadGeometry.PATH = '/search/address/road/geometry';
